interface IIconExclamationCircleProps {
  className?: string;
}

export const IconExclamationCircle = ({ className }: IIconExclamationCircleProps) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 7V13H11V7H13ZM12 15.5C12.5523 15.5 13 15.9477 13 16.5V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V16.5C11 15.9477 11.4477 15.5 12 15.5Z"
    />
  </svg>
);
